app.service('productDescriptionGrade', function(productCardConfig, productCardTest, _, localStorage, cookie, front, sessionStorage) {
	var $self, $tab, $description, $techContent;
	var config, isInit = false;
	var isShow = false;
	var timeout = false;

	function setElements() {
		config = productCardConfig.getData();
		$self = $('#product-description-grade');
		$tab = productCardTest.enabled ? $('[data-section-id=opis]') : $('#product-tabs .product-tab-opis');
		$description = $('#description');
		$techContent = productCardTest.enabled ? $('#description-tech-content') : $('.description-tech-details:first', $description);
	}

	function setEvents() {
		$self.on('click', '.button-yes', function() {
			$self.attr('data-step', 4);
			send('GOOD');
		});
		$self.on('click', '.button-no', function() {
			$self.attr('data-step', 2);
		});
		$self.on('click', '.button-more', function() {
			$self.attr('data-step', 5);
		});
		$self.on('click', '.button-close', function() {
			close();
			saveData();
		});
		$self.on('click', '.js-send-grade-bad', function() {
			$self.attr('data-step', 3);
			send('BAD', $('.step-2 textarea', $self).val());
		});
		$self.on('click', '.js-send-grade-other', function() {
			$self.attr('data-step', 3);
			var opinions = $('.js-fake-checkbox.checked', $self).map(function() {
				return $(this).text();
			}).get();
			send('OTHER', $('.step-5 textarea', $self).val(), opinions);
		});
		$self.on('click', '.js-fake-checkbox', function(e) {
			$(e.target).toggleClass('checked');
		});
		_.onScroll(scrollY => checkVisible(scrollY));
		checkVisible($(window).scrollTop());
	}

	function init() {
		if (!isInit && front.euro) {
			isInit = true;
			setElements();
			var stage = JSON.parse(localStorage.getItem('product-description-grade') || "[]");
			var session = sessionStorage.getItem('product-description-isgrade') == 'true';
			if (!session && stage.indexOf(config.id) == -1) {
				setEvents();
			} else {
				$self.remove();
			}
		}
	}

	function checkVisible(scrollTop) {
		var showing = false;
		if ($description.hasClass('full-desc')) {
			var tabOffset = $tab.offset().top;
			var $window = $(window);
			var height = $window.height();
			var techOffset = $techContent.offset().top;
			if (scrollTop + height - tabOffset > 300 && scrollTop + height - techOffset < 20) {
				showing = true;
			} else {
				showing = false;
			}
		}
		if (showing) {
			if (!isShow) {
				show();
			}
		} else {
			hide();
		}
	}

	function show() {
		if (!timeout) {
			timeout = setTimeout(function() {
				isShow = true;
				$self.attr('data-step', 1);
				timeout=false;
			}, 4000);
		}
	}

	function saveData() {
		var stage = JSON.parse(localStorage.getItem('product-description-grade') || "[]");
		stage.push(config.id);
		localStorage.setItem('product-description-grade', JSON.stringify(stage));
		sessionStorage.setItem('product-description-isgrade', 'true');
	}

	function close(){
		hide();
		$self.addClass('end');
	}

	function hide() {
		isShow = false;
		$self.removeAttr('data-step');
		clearTimeout(timeout);
	}

	function send(grade, description = undefined, opinions = undefined) {
		$.ajax({
			url: '/product-description-grade-create.ltr',
			type: 'POST',
			data: {
				productId: config.id,
				grade: grade,
				opinionDescription: description,
				opinions: opinions
			}
		});
		saveData();
		setTimeout(function() {
			close();
		}, 1500);
	}

	return {
		init
	};
});
